export function isGroupSelectable(element: HTMLElement) {
  const checkbox = element.closest(`input[type="checkbox"]`);
  if (!(checkbox instanceof HTMLInputElement)) {
    return false;
  }

  const table = checkbox.closest("table");
  if (!(table instanceof HTMLTableElement)) {
    return false;
  }

  return true;
}

export function toggleGroupSelectable(element: HTMLElement) {
  const checkbox = element.closest(`input[type="checkbox"]`);
  if (!(checkbox instanceof HTMLInputElement)) {
    return;
  }

  const table = checkbox.closest("table");
  if (!(table instanceof HTMLTableElement)) {
    return;
  }

  const selectAll = checkbox.dataset.selectAll;
  if (typeof selectAll === "string" && selectAll.length > 0) {
    const checked = checkbox.checked;

    for (const input of table
      .querySelectorAll(`input[type="checkbox"][name="${selectAll}"]`)
      .values()) {
      if (!(input instanceof HTMLInputElement)) {
        continue;
      }

      input.checked = checked;
    }
  } else {
    const headerCheckbox = table.querySelector(
      `input[type="checkbox"][data-select-all="${checkbox.name}"]`,
    );
    if (!(headerCheckbox instanceof HTMLInputElement)) {
      return;
    }

    let numberOfChecked = 0;
    let numberOfUnchecked = 0;
    for (const input of table
      .querySelectorAll(`input[type="checkbox"][name="${checkbox.name}"]`)
      .values()) {
      if (!(input instanceof HTMLInputElement)) {
        continue;
      }

      if (input.checked) {
        numberOfChecked += 1;
      } else {
        numberOfUnchecked += 1;
      }
    }

    if (numberOfChecked === 0) {
      headerCheckbox.checked = false;
      headerCheckbox.indeterminate = false;
    } else if (numberOfUnchecked === 0) {
      headerCheckbox.checked = true;
      headerCheckbox.indeterminate = false;
    } else {
      headerCheckbox.indeterminate = true;
    }
  }
}
